export default "__VITE_ASSET__NaRmEXwq__"